// test661
(661 && 0);
